import {Init} from '@/core/Init'
import {APP_EVT} from '@/core/config/constants'

class DesignNotes {

	constructor() {

		Init.emitter.on(APP_EVT.TOGGLE_NOTES, this.toggleEditNotes);
		Init.emitter.on(APP_EVT.RETRIEVE_SUCCESS, this.clearNotes);

		$('#panel-design-notes .handle .btn-close').on('click', function (this) {

			Init.emitter.emit([APP_EVT.TOGGLE_NOTES]);

		});

	}


	/** ***************************************************************************
	 * ACTIVATE NOTE OPTIONS
	 * @param {boolean} state
	 */
	toggleEditNotes = (): void => {

		let state: boolean = Init.notes_active;

		//console.log(state);

		if (state === false) {

			this.showEditNotes();

		} else {

			this.hideEditNotes();

		}

	};

	showEditNotes = (): void => {

		$('#panel-design-notes').show();
		Init.notes_active = true;
		$('#tool-btns #btn-notes-toggle').addClass('active');

	};

	hideEditNotes = (): void => {

		$('#tool-btns #btn-notes-toggle').removeClass('btn-active');
		Init.notes_active = false;
		$('#panel-design-notes').hide();

	};

	clearNotes = (): void => {

		$('#panel-design-notes .content').val('');

	};

	loadNotes = (note: string): void => {

		$('#panel-design-notes .content').val(note);

	};

	getNotes = (): string => {

		let note: string = String($('#panel-design-notes .content').val());

		return note;

	};
}

export {DesignNotes};
